import React from "react";
import {ApiBankInfo, ApiBuildingInfo, GeneralOperatingData} from "./solutrakApiService";
import {DetailRow} from "../../components/NewAlternativeView/DetailRow";
import {BankSelector} from "../../components/NewAlternativeView/BankAndDeviceSelectors";

type GeneralOperatingDataProps = {
    selectedBuilding: ApiBuildingInfo | null;
    selectedBank: ApiBankInfo | null;
    isLoadingGeneralOperatingData: boolean;
    generalOperatingData: GeneralOperatingData[];
    generalOperatingDataError?: string | null;
    handleBankSelect: (bank: ApiBankInfo) => void;
};

export default function GeneralOperatingDataView({selectedBuilding, selectedBank, isLoadingGeneralOperatingData, generalOperatingData, generalOperatingDataError, handleBankSelect} : GeneralOperatingDataProps) {
    return (
        <>
            {/* Bank Selector */}
            {selectedBuilding && (
                <div className="p-4 pb-0 space-y-3">
                    {/* Bank Selector */}
                    <BankSelector selectedBuilding={selectedBuilding} selectedBank={selectedBank} handleBankSelect={handleBankSelect} />
                </div>
            )}

            {/* General Operating Data Display Area */}
            {(() => {
                if (!selectedBank) {
                    return <div className="p-4 text-slate-400 text-center">Please select a bank to view
                        operating data.</div>;
                }

                if (isLoadingGeneralOperatingData) {
                    return <div className="p-4 text-slate-400 text-center">Loading data...</div>;
                }


                if (generalOperatingDataError) {
                    return <div className="p-4 text-red-500 text-center">Error loading operating
                        data: {generalOperatingDataError}</div>;
                }


                if (!generalOperatingData) {
                    return <div className="p-4 text-slate-400 text-center">No operating data found for the
                        selected device and period.</div>;
                }
                return (

                    <div className="grid grid-cols-4 gap-6">
                        {generalOperatingData.map((data) => {
                            const device = selectedBank.deviceInfos.find(device => device.deviceId === data.deviceId);
                            const name = device.deviceName || `Device ${data.deviceId}`;
                            return (
                                <div
                                    className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50">
                                    <h3 className="text-xl font-medium text-white mb-2">{name}</h3>

                                    {/* RUN SUMMARY */}
                                    <div className="mb-4">
                                        <div className="flex justify-between text-sm text-slate-400 mb-1">
                                            <span>Up</span>
                                            <span
                                                className="text-white font-medium">{data.TotalUpCount}</span>
                                        </div>
                                        <div className="flex justify-between text-sm text-slate-400 mb-1">
                                            <span>Down</span>
                                            <span
                                                className="text-white font-medium">{data.TotalDownCount}</span>
                                        </div>
                                        <div className="flex justify-between items-center mt-2">
                                            <span className="text-slate-300 text-sm">Total Run Count</span>
                                            <span
                                                className="text-3xl font-bold text-white">{data.TotalRunCount}</span>
                                        </div>
                                        <p className="text-xs text-slate-500 italic">Run Count = Up +
                                            Down</p>
                                    </div>

                                    {/* OPERATIONAL DETAILS */}
                                    <div className="space-y-2 border-t border-slate-700/50 pt-4 mt-2">
                                        <DetailRow label="Door Open" value={data.TotalOpeningCount}/>
                                        <DetailRow label="Door Close" value={data.TotalClosingCount}/>
                                        <DetailRow label="Nudging" value={data.TotalNudgingCount}/>
                                        <DetailRow label="Reopen" value={data.TotalReopenCount}/>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })()}
        </>
    );
}
